'use client'

import s1 from "@/assets/stylist-1.jpg";
import s2 from "@/assets/stylist-2.jpg";
import s3 from "@/assets/stylist-3.jpg";
import s4 from "@/assets/stylist-4.jpg";
import type { Stylist } from "@/components/site/BookingModal";

export const stylists: Stylist[] = [
  { name: "Eloise Marchetti", specialty: "Master Stylist", image: s1, service: "Signature Cut & Style", price: 22000 },
  { name: "Auguste Lange", specialty: "Senior Colorist", image: s2, service: "Balayage & Gloss", price: 38000 },
  { name: "Naomi Okafor", specialty: "Texture Specialist", image: s3, service: "Curl Sculpting Ritual", price: 26000 },
  { name: "Rin Takeda", specialty: "Skin & Nail Atelier", image: s4, service: "Glow Facial + Manicure", price: 29500 },
];
